import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid } from '@mui/material'
import { CardTitle } from '../../../../../components/card/NewCard'
import i18n from 'simple-react-i18n'
import Input from '../../../../../components/forms/Input'
import { shapeTaxonWithLink } from '../../shapes/ShapeTaxonWithLink'

const EcoFriendlyFeaturesCharacteristics = ({ taxon, onChange, disabled }) => {
    return (
        <Card>
            <CardTitle title={i18n.characteristics} />
            <CardContent>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <Input
                            title={ i18n.mainCharacteristics }
                            value={ taxon.characteristics }
                            onChange={ v => onChange({ characteristics: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={ i18n.morphology }
                            value={ taxon.morphology }
                            onChange={ v => onChange({ morphology: v }) }
                            disabled={ disabled }
                        />
                    </Grid>

                    <Grid size={6}>
                        <Input
                            title={ i18n.ecology }
                            value={ taxon.ecology }
                            onChange={ v => onChange({ ecology: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={ i18n.observations }
                            value={ taxon.observations }
                            onChange={ v => onChange({ observations: v }) }
                            disabled={ disabled }
                        />
                    </Grid>

                    <Grid size={6}>
                        <Input
                            title={ i18n.populationAspect }
                            value={ taxon.populationAspect }
                            onChange={ v => onChange({ populationAspect: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={ i18n.doNotMixUp }
                            value={ taxon.doNotMixUp }
                            onChange={ v => onChange({ doNotMixUp: v }) }
                            disabled={ disabled }
                        />
                    </Grid>

                    <Grid size={6}>
                        <Input
                            title={ i18n.comments }
                            value={ taxon.contributorComment }
                            onChange={ v => onChange({ contributorComment: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={ i18n.flowering }
                            value={ taxon.flowering }
                            onChange={ v => onChange({ flowering: v }) }
                            disabled={ disabled }
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

EcoFriendlyFeaturesCharacteristics.propTypes = {
    taxon: shapeTaxonWithLink,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
}

export default EcoFriendlyFeaturesCharacteristics